import dynamic from 'next/dynamic'
import { analytics } from '@helpers/analytics'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'
import styles from '../styles.module.scss'
import modalstyles from './sizeTableModal.module.scss'

const Modal = dynamic(() => import('@components/ui/Modal'))

type TableData = {
  readonly thead: readonly {
    readonly defaultValue: string
    readonly value: string
  }[]
  readonly tbody: readonly {
    readonly defaultValue: string
    readonly value: string
  }[]
}

type SizeSubtitleWithTableModalProps = {
  modalOpen: boolean
  toggleModal: () => void
  sizeType: string
  tableData: TableData
  title: string
  byline: string
}

function SizeSubtitleWithTableModal({
  modalOpen,
  toggleModal,
  sizeType,
  tableData,
  title,
  byline
}: SizeSubtitleWithTableModalProps) {
  const handleOpenModal = () => {
    toggleModal()
    analytics('Click', { label: title })
  }

  return (
    <>
      <div className={styles.subtitle__container}>
        <h2 className={styles.subtitle}>{sizeType}</h2>
        <div className={styles.subtitle}>
          <ButtonMinimal underlined onClick={handleOpenModal}>
            {title}
          </ButtonMinimal>
        </div>
      </div>
      {modalOpen && (
        <Modal
          onClose={toggleModal}
          openedModal={modalOpen}
          classes={modalstyles.SizeTableModalWrapper}
        >
          <h2>{title}</h2>
          <p className={styles.subtitle}>{byline}</p>
          <table className={modalstyles.ModalTable}>
            <thead>
              {tableData.thead.map((row, index) => (
                <tr key={index}>
                  <th>{row.defaultValue}</th>
                  <th>{row.value}</th>
                </tr>
              ))}
            </thead>
            <tbody>
              {tableData.tbody.map((row, index) => (
                <tr key={index}>
                  <td className={modalstyles.ModalTable__defaultColumn}>
                    {row.defaultValue}
                  </td>
                  <td>{row.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal>
      )}
    </>
  )
}

export default SizeSubtitleWithTableModal
